module.exports = __webpack_public_path__ + "static/img/11.060e3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/eng/11.png
// module id = vm52
// module chunks = 0